module.exports = __webpack_public_path__ + "static/media/cry.53020b89.png";